import {Button, Input} from "antd";
import {ReactNode, useEffect, useState} from "react";
import EmptyWhatsapp from "../../../assets/images/empty-whatsapp.png";
import TextAreaNext from "../../forms/textAreaNext/TextAreaNext";
import Checkbox from "../../forms/checkbox/Checkbox";
import Sunglasses from "../../../assets/images/sunglasses.png";
import {CloseOutlined, RightOutlined, UserOutlined} from "@ant-design/icons";
import StoreWhatsappImage from "../../../assets/images/store-whatsapp-image.png";
import useUserContext from "../../../hooks/useUserContext";
import "./pre-creation-step.css";
import {FormValuesProps} from "../../modals/notificationModals/NewNotificationModal";
import MessagePreview from "../../messagePreview/MessagePreview";
import {useSteps} from "../../../hooks/useSteps";
import ButtonGroup from "../../forms/buttonGroup/ButtonGroup";
import {FlowTriggerProps} from "../../../types/FlowTriggerProps";
import {FlowTypeProps} from "../../../types/FlowTypeProps";
import {getMessageTypeIcon} from "../../../utils/getMessageTypeIcon";

interface StepProps {
    formValues: FormValuesProps;
    setFormValues: (values: FormValuesProps) => void;
    flowTriggerId: number;
    possibleMessageTypes: FlowTypeProps[];
}

const PreCreationStep = ({ formValues, setFormValues, flowTriggerId, possibleMessageTypes }: StepProps) => {
    const { goBack, goNext } = useSteps();
    const onSelect = (messageTypeId: number) => {
        setFormValues( { ...formValues, requiresConsent: messageTypeId === 2 });
    }

    return <>
        <div className="step-container pre-creation-step">
            <div className="top">
                <div className="title">
                    Define Your Communication Purpose
                </div>
                <div className="description">
                    Selecting the correct type is crucial for compliance with WhatsApp's policies. Templates with mismatched types and content may be rejected or, in severe cases, lead to the disabling of your Meta account. Ensure your content aligns with the selected type and adheres to customer consent requirements to avoid issues.
                </div>
                <ButtonGroup descriptionAlwaysOn={true} items={possibleMessageTypes?.map(messageType => ({
                    id: messageType.id,
                    title: messageType.title,
                    description: messageType.description,
                    icon: getMessageTypeIcon(messageType.id),
                    isSelected: false,
                }))} onClick={(id: number | string) => {
                    onSelect(id as number);
                    goNext();
                }} />
            </div>
            {/*<div className="bottom">*/}
            {/*    <div className="buttons">*/}
            {/*        <Button type="default" size="large" className="back-step-button" onClick={goBack} icon={<CloseOutlined />}>Cancel</Button>*/}
            {/*        <Button type="primary" size="large" className="next-step-button" onClick={goNext} icon={<RightOutlined />} disabled={!title || !content}>Next Step</Button>*/}
            {/*    </div>*/}
            {/*</div>*/}
        </div>
    </>
}

export default PreCreationStep;